// extracted by css-extract-rspack-plugin
export default {"flex":"EmployeeList__flex--FXa3V"};